import BaseModel from '../base/BaseModel.model';
export default class Institution extends BaseModel {

   public institutionsId?: number;
   public name?: string;
   

    init(){
       this.institutionsId = 0;
       this.name = "";
    }

}